import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';

const Tips1Field: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	if (customerForFullInfo?.defaultTips[1]) {
		return (
			<FullInfoField
				label={customerForFullInfo.defaultTips[1].isDefault ? 'tips1DefaultLabel' : 'tips1Label'}
				value={customerForFullInfo.defaultTips[1].value}
			/>
		);
	}
	return <FullInfoField label="tips1Label" value={null} />;
};

export default Tips1Field;
